import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × MATISSE: Geometry with joy
// Cutouts, organic shapes, vivid contrasts
export function VasarelyMatisseMode({ brand }: ModeRendererProps) {
  return (
    <g>
      {/* Joyful color background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.deep} />

      <g transform="translate(397 540)">
        {/* Organic cutout shapes */}
        {[
          { d: "M -120 -100 Q -80 -150, -40 -100 T 0 -100 Q 20 -80, 0 -60 T -40 -60 Q -80 -80, -120 -100 Z", color: brand.aqua },
          { d: "M 140 -80 Q 180 -120, 220 -80 Q 200 -40, 180 -20 Q 160 -40, 140 -80 Z", color: brand.violet },
          { d: "M -140 120 Q -100 80, -60 100 Q -80 140, -100 160 Q -120 140, -140 120 Z", color: brand.amber },
          { d: "M 130 140 Q 170 100, 210 130 Q 190 170, 160 180 Q 140 160, 130 140 Z", color: brand.aqua },
        ].map((shape, i) => (
          <path key={i} d={shape.d} fill={shape.color} opacity="0.5" />
        ))}

        {/* Joyful geometric forms */}
        {Array.from({ length: 12 }).map((_, i) => {
          const angle = (i * Math.PI) / 6;
          const r = 160;
          const x = Math.cos(angle) * r;
          const y = Math.sin(angle) * r;
          const size = 40 + Math.sin(i) * 15;
          
          return (
            <ellipse
              key={i}
              cx={x}
              cy={y}
              rx={size}
              ry={size * 1.4}
              fill={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
              opacity="0.4"
              transform={`rotate(${angle * 20} ${x} ${y})`}
            />
          );
        })}

        {/* Optical cutout grid */}
        {Array.from({ length: 10 }).map((_, i) =>
          Array.from({ length: 12 }).map((_, j) => {
            const x = (i - 4.5) * 55;
            const y = (j - 5.5) * 50;
            const organic = Math.sin(i * 0.7 + j * 0.6) * 10;
            const colors = [brand.aqua, brand.violet, brand.amber];
            const colorIndex = (i + j) % 3;
            
            return (
              <ellipse
                key={`${i}-${j}`}
                cx={x + organic}
                cy={y - organic * 0.5}
                rx="18"
                ry="24"
                fill={colors[colorIndex]}
                opacity="0.15"
                transform={`rotate(${organic * 3} ${x} ${y})`}
              />
            );
          })
        )}

        {/* Vivid contrast waves */}
        {Array.from({ length: 8 }).map((_, i) => {
          const y = -200 + i * 50;
          const points = Array.from({ length: 30 }).map((_, j) => {
            const x = -300 + j * 20;
            const wave = Math.sin(j * 0.4 + i * 0.5) * 35;
            return `${x},${y + wave}`;
          }).join(" ");
          
          return (
            <polyline
              key={i}
              points={points}
              fill="none"
              stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
              strokeWidth="8"
              opacity="0.3"
              strokeLinecap="round"
            />
          );
        })}

        {/* Joyful circles */}
        {Array.from({ length: 15 }).map((_, i) => {
          const r = 30 + i * 18;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
              strokeWidth="3"
              opacity={0.25 - i * 0.012}
            />
          );
        })}

        {/* Organic center */}
        <ellipse cx="0" cy="0" rx="80" ry="60" fill={brand.violet} opacity="0.3" />
        <ellipse cx="0" cy="0" rx="60" ry="80" fill={brand.aqua} opacity="0.25" />
        <circle cx="0" cy="0" r="40" fill={brand.amber} opacity="0.35" />

        {/* Simplicity markers */}
        {[-1, 1].map((xDir) =>
          [-1, 1].map((yDir) => (
            <circle
              key={`${xDir}-${yDir}`}
              cx={xDir * 200}
              cy={yDir * 180}
              r="20"
              fill={brand.amber}
              opacity="0.4"
            />
          ))
        )}
      </g>

      {/* Joyful inscription */}
      <text x="397" y="1030" textAnchor="middle" fontFamily="serif" fontSize="11" fill={brand.aqua} opacity="0.6" fontStyle="italic">
        joie géométrique
      </text>
    </g>
  );
}
